/* eslint-disable camelcase */
export interface Audio {
    ativar: boolean
}

export interface Empregador {
    id: string
    nome?: string
    razao_social: string
    cnpj: string
    cpf: any
    cno_caepf: any
}

export interface OpcoesLocalizacao {
    ativar: boolean
    verificar_acuracia: boolean
    detectar_manipulacao: boolean
    distancia_maxima_do_local_de_trabalho: number
}

export interface Foto {
    qualidade: number
    largura_maxima: number
    altura_maxima: number
    temporizador: number
    deteccao_facial: boolean
    deteccao_facial_acuracia: number
    reconhecimento_facial: boolean
    reconhecimento_facial_acuracia: number
    reconhecimento_facial_precede_pin: boolean
    deteccao_de_vivencia: boolean
    deteccao_de_vivencia_acuracia: number
}

export interface Seguranca {
    ativar_recaptcha: boolean
    frequencia_de_sincronizacao: number
    validade_da_sessao: any
    aprovacao_automatica: boolean
    confirmar_dados: boolean
    permitir_baixar_comprovante_durante_marcacao: boolean
    manter_tela_de_coletor_coletivo_sempre_ligada: boolean
    temporizador_para_confirmar_dados_sem_contato: any
    permitir_marcacao_com_horario_automatico_desativado: boolean
    permitir_marcacao_longe_local_de_trabalho: boolean
    permitir_marcacao_face_nao_reconhecida: boolean
    mostrar_nome_da_empresa: boolean
}

export interface OpcoesPerfilDeColetor {
    foto: Foto
    audio: Audio
    localizacao: OpcoesLocalizacao
    seguranca: Seguranca
}

export interface PerfilDeColetor {
    nome: string
    opcoes: OpcoesPerfilDeColetor
    tipo: string
    id: string
    padrao: boolean
}

export interface JornadaEmAndamento {
    id: string
    empregado_id: string
    dia: string
    marcacoes_id: string[]
    correcoes_de_marcacao_id: any[]
}

export interface Marcacao {
    id: string
    empregado_id: string
    horario: string
    momento_da_jornada: string
    origem: string
}

export interface CorrecaoDeMarcacao {
    id: string
    empregado_id: string
    horario: string
    momento_da_jornada: string
    origem: string
    marcacao_id: string
}

export interface OpcoesDeMarcacao {
    ativar_marcacao_com_foto: boolean
    ativar_reconhecimento_facial: boolean
    ativar_marcacao_sequencial: boolean
    exibir_momento_da_jornada_se_marcacao_sequencial: boolean
    omitir_botoes_de_pausa_no_registro: boolean
    avisar_nao_cumprimento_interjornada: boolean
    ativar_registro_automatico_de_pausa: boolean
    ativar_marcacao_com_voz_no_app: boolean
    ativar_marcacao_com_voz_na_web: boolean
    permitir_marcacao_em_qualquer_local: boolean
    exibir_jornada_no_aplicativo: boolean
    exibir_feedback_no_applicativo: boolean
    permitir_multiplas_pausas: boolean
    forcar_modal_de_requisicao_de_voz: boolean
    exibir_modal_de_confirmacao_da_marcacao: boolean
}

export interface Empregado {
    id: string
    id_repp: string
    nome: string
    cpf: string
    empregador_id: string
    locais_de_trabalho_id: string[]
    regra_de_calculo_id: string
    pin: string
    demitido: boolean
    opcoes_de_marcacao: OpcoesDeMarcacao
}

export interface JornadaDoDia {
    id: string
    empregado_id: string
    nome: string
    tipo: string
    dia: string
    inicio: string
    pausa: string
    retorno: string
    fim: string
}

export interface SincronizacaoDoUsuario {
    empregado: Empregado
    jornada_do_dia: JornadaDoDia
    jornada_em_andamento: JornadaEmAndamento
    marcacoes: Marcacao[]
    correcoes_de_marcacao: CorrecaoDeMarcacao[]
}

export type MarcacoesEmAndamento = {
    correcoes_de_marcacao_id: string[],
    marcacoes_id: string[],
}

export enum MomentoDaJornada {
    Entrada = 'Entrada',
    Pausa = 'Pausa',
    RetornoPausa = 'Retorno Pausa',
    Saida = 'Saída'
}

export interface ConfiguracoesDeColetores {
    pode_registar_coletor_movel: boolean
    pode_registar_coletor_web: boolean
    tem_atividades: boolean
    tem_qrcode: boolean
    tem_reconhecimento_facial: boolean
    logo_url: string
    logo_toolbar: any
    logo_navdrawer: any
}

export interface ConfiguracoesDeFront {
    limiar_de_duracao_da_jornada: number
}

export interface Cliente {
    id: string
    nome: string
    configuracoes_de_coletores: ConfiguracoesDeColetores
    configuracoes_de_front: ConfiguracoesDeFront
}

export interface LocaisReppPorEmpregador {
    [key: string]: string | undefined;
}

export interface LocalizacaoColetor {
    latitude: number
    longitude: number
}

export interface Local {
    id: string
    locais_repp_por_empregador: LocaisReppPorEmpregador
    nome: string
    endereco: string
    localizacao?: LocalizacaoColetor
    timezone: string
    aceita_timezone_do_coletor: boolean
    ativo: boolean
}

export interface SincronizacaoWeb {
    perfil_de_coletor: PerfilDeColetor
    cliente: Cliente
    locais: Local[]
    empregadores: Empregador[]
}

export interface EstadoSincronizacao {
    pin: string
    sincronizacaoWeb: SincronizacaoWeb
    sincronizacaoUsuario: SincronizacaoDoUsuario
    sincronizacaoWebFinalizada: boolean
    tentativasSincronizacaoWeb: number
    tentativasSincronizacaoPin: number
    erroSincronizarPin: boolean
}
/* eslint-enable camelcase */
